'use strict';

import _ from 'underscore';
import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import update from 'react/lib/update';
import UserStore from './UserStore';
import ZineStore from './ZineStore';
import isBestOf2014Special from '../utils/isBestOf2014Special';
import { createStore, mergeIntoBag, isInBag } from '../utils/StoreUtils';
import parseStampSegment from '../utils/parseStampSegment';

var _stamps = {};

var StampStore = createStore({
  contains(id, fields) {
    return isInBag(_stamps, id, fields);
  },

  get(id) {
    return _stamps[id];
  },

  getPrimaryZine(id) {
    var stamp = this.get(id),
        specialSlug = stamp.zines.filter(isBestOf2014Special)[0];

    if (specialSlug) {
      return ZineStore.get(specialSlug);
    }

    if (stamp.primaryZine) {
      return ZineStore.get(stamp.primaryZine);
    }

    var zines = stamp.zines.map(ZineStore.get),
        max = _.max(zines, z => z.subscriberCount);

    if (!_.isEmpty(max)) {
      return max;
    }
  }
});

StampStore.dispatchToken = AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([UserStore.dispatchToken, ZineStore.dispatchToken]);

  var { zineSlug, response, type, stampSegment } = payload.action,
      entities = response && response.entities,
      receivedStamps = entities && entities.stamps,
      receivedDrafts = entities && entities.drafts,
      me = UserStore.getMe(),
      stampId;

  if (stampSegment) {
    stampId = parseStampSegment(stampSegment).stampId;
  }

  switch (type) {
  case ActionTypes.LIKE_STAMP:
  case ActionTypes.UNLIKE_STAMP_ERROR:
    _stamps[stampId] = update(_stamps[stampId], {
      isLiked: {
        $set: true
      },
      likeCount: {
        $apply: (x) => x + 1
      },
      likes: {
        $apply: (likes) => _.union([me.id], likes)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.UNLIKE_STAMP:
  case ActionTypes.LIKE_STAMP_ERROR:
    _stamps[stampId] = update(_stamps[stampId], {
      isLiked: {
        $set: false
      },
      likeCount: {
        $apply: (x) => x - 1
      },
      likes: {
        $apply: (likes) => _.without(likes, me.id)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.SUBMIT_STAMP_TO_ZINE:
    _stamps[stampId] = update(_stamps[stampId], {
      pendingZines: {
        $apply: pendingZines => _.union([zineSlug], pendingZines)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.SUBMIT_STAMP_TO_ZINE_ERROR:
    _stamps[stampId] = update(_stamps[stampId], {
      pendingZines: {
        $apply: pendingZines => _.without(pendingZines, zineSlug)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.ADD_STAMP_TO_ZINE:
  case ActionTypes.REMOVE_STAMP_FROM_ZINE_ERROR:
    _stamps[stampId] = update(_stamps[stampId], {
      primaryZine: {
        $apply: primaryZine => primaryZine === null ? zineSlug : primaryZine
      },
      zines: {
        $apply: zines => _.union([zineSlug], zines)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.ADD_STAMP_TO_ZINE_ERROR:
  case ActionTypes.REMOVE_STAMP_FROM_ZINE:
    _stamps[stampId] = update(_stamps[stampId], {
      primaryZine: {
        $apply: primaryZine => primaryZine === zineSlug ? null : primaryZine
      },
      zines: {
        $apply: zines => _.without(zines, zineSlug)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
    _stamps[stampId] = update(_stamps[stampId], {
      pendingZines: {
        $apply: pendingZines => _.without(pendingZines, zineSlug)
      },
      zines: {
        $apply: zines => _.union([zineSlug], zines)
      }
    });
    StampStore.emitChange();
    break;

  case ActionTypes.REJECT_STAMP_FROM_ZINE_SUCCESS:
    _stamps[stampId] = update(_stamps[stampId], {
      pendingZines: {
        $apply: pendingZines => _.without(pendingZines, zineSlug)
      }
    });
    StampStore.emitChange();
    break;
  }

  if (receivedStamps) {
    mergeIntoBag(_stamps, receivedStamps);
  }

  if (receivedDrafts) {
    mergeIntoBag(_stamps, receivedDrafts);
  }

  if (receivedDrafts || receivedStamps) {
    StampStore.emitChange();
  }
});

module.exports = StampStore;



/** WEBPACK FOOTER **
 ** ./stores/StampStore.js
 **/